import React from 'react';
import PropTypes from 'prop-types';

const TooltipWrapper = ({ children, title, placement, ...extras }) => {
  const tooltipDynamicAttr = {
    [`data-tooltip-${placement}`]: title
  };
  return (
    <span style={{ position: 'relative' }}>
      <span
        {...tooltipDynamicAttr}
        {...extras}
      >
        {children}
      </span>
    </span>
  );
};

TooltipWrapper.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired
};

const TooltipWrapperSup = ({ sup, placement, title }) => (
  <TooltipWrapper
    placement={placement}
    title={title}
  >
    <sup>{sup}</sup>
  </TooltipWrapper>
);

TooltipWrapperSup.propTypes = {
  sup: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  title: PropTypes.string
};

export {
  TooltipWrapper,
  TooltipWrapperSup,
};
